import React, { useState, useEffect, useContext } from 'react';
import { AppDataContext, VLink } from "./AppDataContext";

export function Footer(props) {
    const context = useContext(AppDataContext);

    const [goToTopVisible, setGoToTopVisible] = useState(false);

    const goToTop = () => {
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // When the user scrolls down 20px from the top of the document, show the button
    const handleScroll = () => setGoToTopVisible(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20);

    return (
        <>
            <footer>
                <div class="container">
                    <div class="row align-items-center pt-4">
                        <div class="col-12 col-md-4 pb-4 text-center text-md-center text-xl-start copyright">
                            <p>&copy;2019-{(new Date()).getFullYear()} Bid Next Door. All Rights Reserved. <span class="d-none">v{context.softwareVersion}</span></p>
                        </div>
                        <div class="col pb-4 footer-links">
                            <ul class="float-none float-md-end text-center text-xl-end">
                                <li><VLink to="/about" title="About Us">About Us</VLink></li>
                                <li><VLink to="/terms" title="Terms & Conditions">Terms & Conditions</VLink></li>
                                <li><VLink to="/privacy" title="Privacy Policy">Privacy Policy</VLink></li>
                                <li><VLink to="/contact" title="Contact Us">Contact Us</VLink></li>
                                <li><VLink to="/sell" title="Sell on Bid Next Door">Sell on Bid Next Door</VLink></li>
                                <li><VLink to="/faq" title="FAQs">FAQs</VLink></li>
                            </ul>
                        </div>
                    </div>
                </div>

     
            </footer>
            {goToTopVisible &&
                <button onClick={goToTop} class="position-fixed btn btn-icon-only btn-secondary scrollToTopBtn" title="Go to top">
                    <i class="bi bi-arrow-up-short"></i>
                </button>
            }
        </>
    );
}
